export default "__VITE_ASSET__C_ECdUl9__"